import { useMemo } from 'react'

import { ThenPlace } from 'components/block/Then/Then.constants'
import { thenPartPath } from 'components/block/Then/Then.paths'
import { ratingPath } from 'components/page/RatingWave/Rating.paths'
import { chatPath, contactPath, redirectAfterAuthPath } from 'components/paths'
import { removeLocale } from 'components/system/system.functions'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import { useAuthorizationPath } from 'hooks/useAuthorizationLink'
import { useLayoutContext } from 'hooks/useLayoutContext'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

export const useChatUrl = (profileId: number) => {
  const { baseUrl } = useLayoutContext()
  const authorizationPath = useAuthorizationPath()

  const { authorized, locale } = useShallowEqualSelector(
    ({ authorizationReducer: { authorized }, systemReducer: { locale } }) => ({
      authorized,
      locale,
    })
  )

  const isRatingPath = baseUrl.includes(ratingPath)

  return useMemo(() => {
    if (authorized) {
      return mergeAllUrls(baseUrl, chatPath, profileId, contactPath)
    }

    if (isRatingPath) {
      return authorizationPath
    }

    return mergeAllUrls(
      locale,
      authorizationPath,
      redirectAfterAuthPath,
      removeLocale(baseUrl),
      thenPartPath,
      ThenPlace.messenger
    )
  }, [authorizationPath, authorized, baseUrl, isRatingPath, locale, profileId])
}
